import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { applyStoredTextSize } from './lib/textSize'
import './styles/index.css'

// Before the first render, so larger text never draws at 100% first (h 1572).
applyStoredTextSize()

// A page left open across a deploy still asks for the old build's screen files, which the deploy removed
// ("Failed to fetch dynamically imported module"). Load the new build instead, once a minute at most, so a
// file that is really missing shows the screen's error rather than reloading forever.
window.addEventListener('vite:preloadError', (event) => {
  let last = 0
  try { last = Number(sessionStorage.getItem('control.reloadedForDeploy')) || 0 } catch { /* no storage */ }
  if (Date.now() - last < 60_000) return
  try { sessionStorage.setItem('control.reloadedForDeploy', String(Date.now())) } catch { /* no storage */ }
  event.preventDefault()
  window.location.reload()
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
